
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire570d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire570d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kReb3", function(module, exports) {

$parcel$export(module.exports, "register", () => $f2f3c12eea468279$export$6503ec6e8aabbaf, (v) => $f2f3c12eea468279$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f2f3c12eea468279$export$f7ad0328861e2f03, (v) => $f2f3c12eea468279$export$f7ad0328861e2f03 = v);
var $f2f3c12eea468279$export$6503ec6e8aabbaf;
var $f2f3c12eea468279$export$f7ad0328861e2f03;
"use strict";
var $f2f3c12eea468279$var$mapping = new Map();
function $f2f3c12eea468279$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f2f3c12eea468279$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f2f3c12eea468279$var$resolve(id) {
    var resolved = $f2f3c12eea468279$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f2f3c12eea468279$export$6503ec6e8aabbaf = $f2f3c12eea468279$var$register;
$f2f3c12eea468279$export$f7ad0328861e2f03 = $f2f3c12eea468279$var$resolve;

});

var $89c6b2e1ec0da4f2$exports = {};

(parcelRequire("kReb3")).register(new URL("", import.meta.url).toString(), JSON.parse('["hP6JW","index.560b4c97.js","6N2pL","Food-Plaza.b8835a43.png","lzd65","Burger_Img.d05b1710.png","i5W77","Cart.2f4f2186.js","jKWzL","Cart-empty.cdd853dc.png","6tzgj","RestaurantCollectionsInfo.a8aee5af.js"]'));


//# sourceMappingURL=index.runtime.f2529965.js.map
